var map = {
	"./basketball.svg": 317,
	"./building.svg": 318,
	"./chevron-down-white.svg": 380,
	"./facebook.svg": 381,
	"./flag-icon--en.svg": 382,
	"./flag-icon--hu.svg": 383,
	"./instagram.svg": 384,
	"./linkedin.svg": 385,
	"./loader-icon.svg": 325,
	"./smiley.svg": 319,
	"./subscribe.svg": 243,
	"./tree.svg": 320,
	"./youtube.svg": 386
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 379;